// extracted by mini-css-extract-plugin
export var label = "_h0-2";
export var slideContainer = "_h0-0";
export var slider = "_h0-1";